import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PagedData } from 'sabis-grid2';
import { AppNavigationService } from '../core/navigation/app-navigation.service';
import { GeneralApplicationsDashboardDTO, GeneralApplicationsDashboardListFilterDTO } from '../reports/models/api-models';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(@Inject('API_URL') private _apiUrl: string
    , private _http: HttpClient
    , private _appNavigation: AppNavigationService
  ) { }

  public getDashboardMainData(): Observable<DashboardMainDTO> {
    let url: string = `${this._apiUrl}/admin/dashboard/main-data`;

    return this._http.get<DashboardMainDTO>(url);
  }

  public myGeneralApplicationsSelected(countryId: number, getUnprocessedApplications: boolean): void {
    this._appNavigation.goToMyGeneralApplications(countryId, getUnprocessedApplications);
  }

  public myGeneralApplicationsClick(): void {
    this._appNavigation.goToGeneralApplications();
  }

  public myUnprocessedGeneralApplicationsClick(): void {
    this._appNavigation.goToUnprocessedGeneralApplications();
  }

  public myRequisitionsSelected(): void {
    this._appNavigation.goToJobRequisitionsList(true);
  }

  public liveRequisitionsSelected(): void {
    this._appNavigation.goToJobRequisitionsList(false, true);
  }

  public expiredRequisitionsSelected(): void {
    this._appNavigation.goToJobRequisitionsList(false, false, true);
  }

  public expiringRequisitionsSelected(): void {
    this._appNavigation.goToJobRequisitionsList(false, false, false, false, false, false, true);
  }

  public pendingApprovalRequisitionsSelected(): void {
    this._appNavigation.goToJobRequisitionsList(false, false, false, true);
  }

  public GetMyGeneralApplicationsDashboard(filters: GeneralApplicationsDashboardListFilterDTO): Observable<PagedData<GeneralApplicationsDashboardDTO>> {
    let url: string = `${this._apiUrl}/admin/dashboard/general-applications`;

    return this._http.post<PagedData<GeneralApplicationsDashboardDTO>>(url, filters);
  }

  public failedEmailsSelected(): void {
    this._appNavigation.goToFailedEmails();
  }
}


export interface DashboardMainDTO {
  myRequisitionsCount: number;
  generalApplicationsCount: number;
  unprocessedGeneralApplicationsCount: number;
  liveRequisitionsCount: number;
  expiredRequisitionsCount: number;
  pendingApprovalRequisitionsCount: number;
  expiringRequisitionsCount: number;
  failedEmailsCount: number;
  isApprover: boolean;
}
